import React, { useState, useMemo } from "react";
// import { tempdata } from "../tempData";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from './Table.module.css'
import moment from "moment";

const DataTable = ({ otpData }) => {
  const [showEntries, setShowEntries] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = +showEntries;

  const headers = [
    { name: "S.No.", field: "index", sortable: false },
    { name: "Mobile", field: "mobile", sortable: true },
    { name: "OTP", field: "otp", sortable: true },
  ];

  const commentsData = useMemo(() => {
    //let computedComments = comments;
    let computedComments = otpData || [];

    if (search) {
      const q = search.toLowerCase();
      computedComments = computedComments.filter((row) => {
        const mobile = String(row?.mobile_no ?? row?.mobile ?? "");
        const otp = String(row?.otp ?? row?.otp_code ?? "");
        const status = String(row?.status ?? row?.is_verified ?? row?.verified ?? "");
        return (
          mobile.toLowerCase().includes(q) ||
          otp.toLowerCase().includes(q) ||
          status.toLowerCase().includes(q)
        );
      });
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort((a, b) => {
        const av = a?.[sorting.field];
        const bv = b?.[sorting.field];
        return reversed * String(av ?? "").localeCompare(String(bv ?? ""));
      });
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [otpData, currentPage, search, sorting, ITEMS_PER_PAGE]);

  return (
    <>
      <div className="d-flex justify-content-between">
        {/* <button onClick={()=>console.log(profileData)}>dsdgv</button> */}
        <div>
          Show{" "}
          <select
            onChange={(e) => {
              setShowEntries(e.target.value);
              console.log(e.target.value);
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            {/* <option value='30'>30</option> */}
            {/* <option value='50'>50</option>
                    <option value='100'>100</option> */}
          </select>{" "}
          enteries
        </div>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-bordered mt-3 mb-0">
          <TableHeader
            className={classes.header}
            headers={headers}
            onSorting={(field, order) => setSorting({ field, order })}
          />
          <tbody>
            {commentsData.map((data, index) => (
              <tr key={data?.otp_id ?? data?.id ?? `${index}`}>
                <th scope="row">{index + 1}</th>
                <td>{data?.mobile_no ?? data?.mobile ?? "-"}</td>
                <td>{data?.otp ?? data?.otp_code ?? "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="small ">
        Showing{" "}
        <b>
          {+showEntries < (otpData?.length || 0)
            ? +showEntries
            : (otpData?.length || 0)}
        </b>{" "}
        out of {otpData?.length || 0} enteries
      </p>
      <div className="mt-4">
        <Pagination
          total={totalItems}
          itemsPerPage={ITEMS_PER_PAGE}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default DataTable;
